//import axiosLoadingIndicatorFactory from '../axios-loading-indicator';
import axios from 'axios';
import handlers from './default-handlers';

export default {
    tryLogin(vue, user, password, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.login, {
            user,
            password
        }, {
            params: {
                //day: date.toISODate()
            }
        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    logout(vue, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.logout, {

        }, {
            params: {
                //day: date.toISODate()
            }
        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    frontText(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.configuration.frontText).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    getTexts(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.configuration.getTexts).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
}
